/**
 * Builds OOP action `ctx.params` for embedded / filtered tables.
 * Active table filters (e.g. Id) merge first; ambient / actionParamMap overrides win on key collision.
 */
export function mergeActionExecutionParams(options: {
  tableFilters?: Record<string, unknown>;
  ambient?: Record<string, unknown>;
}): Record<string, string> | undefined {
  const merged: Record<string, string> = {};

  if (options.tableFilters) {
    for (const [key, value] of Object.entries(options.tableFilters)) {
      if (value !== undefined && value !== null && value !== '') {
        merged[key] = String(value);
      }
    }
  }

  if (options.ambient) {
    for (const [key, value] of Object.entries(options.ambient)) {
      if (value !== undefined && value !== null && value !== '') {
        merged[key] = String(value);
      }
    }
  }

  return Object.keys(merged).length > 0 ? merged : undefined;
}
